import axios from "axios";

export function initProjectsLikeButton() {
    document.querySelectorAll('[like-project-button]').forEach(button => {
        let projectId = button.getAttribute('like-project-button')

        button.addEventListener('click', event => {
            event.preventDefault()
            axios.post(`/api/projects/${projectId}/likes`)
                .then(result => {
                    let response = result.data

                    if (response.success) {
                        console.log()
                        document.querySelectorAll(`[like-project-button="${projectId}"]`).forEach((element) => {
                            let projectsCountElem = element.querySelector('[project-likes-count]')
                            if (projectsCountElem) {
                                projectsCountElem.innerHTML = response.data.count
                                if (response.data.currentUserLiked) {
                                    element.querySelector('svg')?.classList.add('filled')
                                } else {
                                    element.querySelector('svg')?.classList.remove('filled')
                                }
                            }


                        })
                    }
                })
        })
    })
}

initProjectsLikeButton();
